export default __webpack_public_path__ + "static/media/flag-es-CT.99d01f1d.svg";